module.exports = __webpack_public_path__ + "img/apple-iphone-8.97d07731.png";